import * as Yup from 'yup';

const HolidaySchema = Yup.object().shape({
  holiday_name: Yup.string().required('Name is required'),
  holiday_date: Yup.string().required('Date is required'),
  office_location_id: Yup.string().required('Select an office'),
});

export default HolidaySchema;
